import {
  TiptapEditorHTMLView,
  TiptapEditorView,
  TiptapOutputType,
  TiptapEditorCommentView,
} from '@amzn/awscat-editor';
import React from 'react';

import { sanitizeCodeBlock } from '../../../../editor/utils';
import {
  ContentViewerContextData,
  withContentViewerContext,
} from '../../../workflow-viewer/ContentViewerContext';
import { WorkflowState, UserCommentState } from '@amzn/awscat-pattern-library-service-model';
import ErrorBoundary from '../../../../editor/ErrorBoundary';
import { fetchImageInBase64Format } from '../../../../editor/utils';
import { IMplServiceClient } from '../../../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../../../api/MplServiceClientFactory';
import AppContextProps from '../../../../contexts/AppContextProps';
import { withAppContext } from '../../../../contexts/AppContext';

interface Props extends AppContextProps {
  contentViewerContext: ContentViewerContextData;
  id?: string;
  value: string | object;
  htmlView?: boolean;
}

function ReadonlyEditorView(props: Props) {
  const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

  const createInlinComment = async (
    startOffset: number,
    endOffset: number,
    textData: string,
    commentData: string,
  ) => {
    const path = props?.id ? ['epics', props.id] : ['epics'];
    // @ts-expect-error TS2722 - strict migration
    await props?.contentViewerContext?.createInlineComment(
      path,
      startOffset,
      endOffset,
      textData,
      commentData,
    );
  };

  const getTaskComments = () => {
    const sectionComments = (props?.contentViewerContext?.inlineComments ?? []).filter(
      (comment) => comment.path[0] === 'epics' && comment.path?.[1] === props.id,
    );
    return sectionComments.filter((comment) => comment.state !== UserCommentState.RESOLVED);
  };

  const taskComments = getTaskComments();
  const { publicationState, isCommentingModeEnabled } = props?.contentViewerContext ?? {};
  const { entities } = props?.appContext ?? {};
  const disableCommentingMode =
    // @ts-expect-error TS2345 - strict migration
    [WorkflowState.PUBLISHED, WorkflowState.DISTRIBUTED].includes(publicationState) ||
    !isCommentingModeEnabled;

  const fetchImage = async (srcUrl: string) => {
    return await fetchImageInBase64Format(srcUrl, mplServiceClient);
  };

  return props.htmlView ? (
    <TiptapEditorHTMLView model={props.value} />
  ) : disableCommentingMode ? (
    <ErrorBoundary
      fallback={
        <TiptapEditorView
          model={sanitizeCodeBlock(props.value)}
          // @ts-expect-error TS2322 - strict migration
          entities={entities}
          fetchImage={fetchImage}
        />
      }
    >
      <TiptapEditorView
        model={sanitizeCodeBlock(props.value)}
        // @ts-expect-error TS2322 - strict migration
        entities={entities}
        fetchImage={fetchImage}
      />
    </ErrorBoundary>
  ) : (
    <ErrorBoundary
      fallback={
        <TiptapEditorCommentView
          model={sanitizeCodeBlock(props.value)}
          comments={taskComments}
          addInlineComment={createInlinComment}
          // @ts-expect-error TS2322 - strict migration
          entities={entities}
          fetchImage={fetchImage}
        />
      }
    >
      <TiptapEditorCommentView
        model={sanitizeCodeBlock(props.value)}
        comments={taskComments}
        addInlineComment={createInlinComment}
        // @ts-expect-error TS2322 - strict migration
        entities={entities}
        fetchImage={fetchImage}
      />
    </ErrorBoundary>
  );
}

export default withContentViewerContext(withAppContext(ReadonlyEditorView));
